
const Social = () => {  

    return (
        <div className="social_media">
            <a target="blank" href="https://github.com/Gopi-Kumar" className="social_media_icon">
                <i className="fab fa-github" aria-hidden="true"></i>
            </a>
            <a target="blank" href="https://www.facebook.com/gopikumar.kaushik.1" className="social_media_icon">
                <i className="fab fa-facebook" aria-hidden="true"></i>
            </a>    
            <a target="blank" href="https://www.linkedin.com/in/gkkaushik/" className="social_media_icon">
                <i className="fab fa-linkedin" aria-hidden="true"></i>
            </a>
            <a target="blank" href="https://twitter.com/gopi9065" className="social_media_icon">
                <i className="fab fa-twitter" aria-hidden="true"></i>
            </a>
            <a target="blank" href="https://twitter.com/GopiKumarKaush1" className="social_media_icon">
                <i className="fab fa-hackerrank" aria-hidden="true"></i>
            </a>
        </div>
    )
}
export default Social;